import React, { useState, useEffect } from 'react';
import { useParams, ScrollRestoration, useNavigate, useLocation } from 'react-router-dom';
// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
import API from '../API'
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import ClubHeader from './ClubHeader';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid'
import List from './List'

// Hook
import useAuth from '../hooks/useAuth';
import { useEmployeeListFetch } from '../hooks/useEmployeeList';
import { useDocumentsListFetch } from '../hooks/useDocumentsListFetch';
// Image

import Grid from './Grid';
import PdfView from './PdfView';

let renderCount = 0

const DocumentsList = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "./";

  const { state, loading, error, setSearchValue, setLoading, setTrigger } = useDocumentsListFetch();




  const handleClick = async (e) => {

    try {

      // eslint-disable-next-line no-restricted-globals
      const confirmation = confirm("Are you sure you want to Delete this document? This action cannot be overturned!")
      if (confirmation) {

        console.log("Sukses, die employee gaan delete word hier")
        await API.deleteFile(e.target.id, auth.auth.accessToken)

        setTrigger(true)


      } else {
        return
      }


    } catch (error) {
      console.log(error)
    }

    console.log("gekliek op" + e.target.id)
    console.log(auth.auth.user.username)

  }

  const showFile = async (e) => {

    try {

      console.log("ShowFile is gekliek")

      navigate(`/pdfview/${e.target.id}/file/${e.target.id}`, { replace: true });


    } catch (error) {
      console.log(error)
    }

    console.log("gekliek op" + e.target.id)
    console.log(auth.auth.user.username)

  }


  const username = auth.auth.user.username

  const access = auth.auth.user.userRole
  // console.log(besluit.besluit[0].besluit)
  console.log(state)

  renderCount++
  return (
    <>

      <Header username={username} role={access} destination={from}></Header>

      {access === "administrator" ?
        <Knoppie
          destination={`/Upload`}
          type={"file"}
          text={'Upload more Files'}
          clickable={true}
        />
        : ""}

      {/* <h1>RenderCount {renderCount/2}</h1> */}
      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={setSearchValue}></SearchBar>

      </div>
      {error ? "error" : ""}

      <List header={`Files count ${state.files?.length}`}
        destination={''}>

        {loading ? <h1>...Loading</h1> : ""}

        {state.files.map((item) => (

          <Thumb
          
          key={item._id}
          clickable={true}
          name={item.name}
          area={item.signed? "signed" : ""}
          root={'file'}
          id={item._id}
          employeeid={item._id}
          >


            {<Knoppie
              clickable={true}
              text={"Delete"}

              employeeid={item._id}
              callback={handleClick}
            >

            </Knoppie>}


          </Thumb>
        ))}

          
          


       


      </List>

    </>
  );
};

export default DocumentsList;

